import { AlertState } from './../../enums/alert-state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Alert } from './../../model/alert';
import { GlobalGridModeService } from './../../services/globalGridMode/globalGridMode.service';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { WorkspaceServiceService } from '../../services/workspace-service.service';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { DataService } from '../../services/data/data.service';
import { ShowAlertModal } from '../modals/alert-modal/show-alert-modal';
import { ShowModalOrderEntry } from '../modals/orderentry/show-order-entry-modal';
import { OrderOperationType } from '../modals/orderentry/orderentry.component';

@Component({
  selector: 'alerts',
  template: require('./alerts.component.html'),
  styles: [require('./alerts.component.css')]
})
export class AlertsComponent implements OnInit, AfterViewInit {
 

  //@ViewChild('getThemNowButton') protected getThemNowButton!: ElementRef;

  //protected getThemNowButtonDefaultFontSize = 25;

  public getThemNowUrl = 'https://jdfn.recurly.com/subscribe/edge-alerts';

  public search!: string;

  public filter: number = 1;

 /* public get getThemNowButtonFontSize()
  {
    return Math.min(this.getThemNowButton.nativeElement.offsetWidth/9.3, this.getThemNowButtonDefaultFontSize);
  }*/

  @ViewChild('alertsList') alertsList!: ElementRef;

  public get filteredAlerts()
  {
    let alerts = this.workspaceService.data.alerts.sort((a, b) => new Date(b.Date) as any - (new Date(a.Date) as any));
    if(this.filter == 2) alerts = alerts.filter(a => this.workspaceService.data.getAlertState(a) == AlertState.Unread);
    if(this.filter == 3) alerts = alerts.filter(a => a.Action != null && a.Action.toLowerCase().includes('open'));
    if(this.filter == 4) alerts = alerts.filter(a => a.Action != null && a.Action.toLowerCase().includes('close'));
    if(this.filter == 5) alerts = alerts.filter(a => a.TradeDirection != null && a.TradeDirection.toLowerCase().includes('long'));
    if(this.filter == 6) alerts = alerts.filter(a => a.TradeDirection != null && a.TradeDirection.toLowerCase().includes('short'));
    if(this.search != null) alerts = alerts.filter(a => (a.Strategy||'').toLowerCase().includes(this.search.toLowerCase()) 
    || (a.CurrencyPair||'').toLowerCase().includes(this.search.toLowerCase())
    || (a.Portfolio||'').toLowerCase().includes(this.search.toLowerCase()));
    return alerts;
  }

  constructor(public workspaceService: WorkspaceServiceService, protected globalGridMode: GlobalGridModeService, protected dataService: DataService, public modalService: NgbModal) {}

  ngOnInit() {
    
  }

  public getTime(alert: Alert)
  {
    if(alert.Date == null) return '';
    return alert.Date.replace('T', ' ');
  }

  public isAlertRead(alert: Alert)
  {
    return this.workspaceService.data.getAlertState(alert) == AlertState.Read;
  }

  public isAlertTraded(alert: Alert)
  {
    return this.workspaceService.data.getAlertState(alert) == AlertState.Traded;
  }
  
  public setAlertRead(alert: Alert)
  {
    if(!this.isAlertRead(alert) && !this.isAlertTraded(alert))
      this.workspaceService.data.setAlertState(alert, AlertState.Read)
  }

  public setAlertTraded(alert: Alert)
  {
    if(!this.isAlertTraded(alert))
      this.workspaceService.data.setAlertState(alert, AlertState.Traded)
  }

  closeAlertClick(event: MouseEvent)
  {
    event.stopPropagation();
    this.workspaceService.data.openedAlertId = -1;
  }

  getAlertShortTradeDirection(alert: Alert)
  {
    if(alert.TradeDirection == null)
      return "";

    return alert.TradeDirection.toLowerCase().includes("short")? "Sell": "Buy";
  }

  public getAlertShortAction(alert: Alert)
  {
    if(alert.Action == null)
      return null;

    const splitted = alert.Action.split(' ');

    if(splitted.length > 1)
      return splitted[0];
    
    return alert.Action;
  }

  public newSymbol(event: MouseEvent, alert: Alert) {
    this.setAlertRead(alert);
    event.stopPropagation();
    this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
    this.globalGridMode.emitSymbolChanged({ symbol: alert.CurrencyPair, overrideLockAllCharts: false });
  }

  public tButtonClick(event: MouseEvent, alert: Alert)
  {
    this.setAlertRead(alert);
    event.stopPropagation();
    this.openOrderModal(alert);
  }

  openOrderModal(alert: Alert) {
    this.setAlertTraded(alert);
    const item = this.workspaceService.data.boxes.find(b => b.Symbol == alert.CurrencyPair)
    if(item == null)
      return;

    ShowModalOrderEntry(
        item.Symbol,
        item.Ask,
        this.modalService,
        alert.TradeDirection != null && alert.TradeDirection.toLowerCase().includes("short")? OrderOperationType.Sell: OrderOperationType.Buy,
        item.Type,
        this.workspaceService.data.mobileMode,
        undefined,
        this.workspaceService.data.newOrderLayout,
    );
  }

  public openAlert(alert: Alert)
  {
    this.setAlertRead(alert);
    this.workspaceService.data.activeAlertId = alert.Id;
    ShowAlertModal(this.modalService, alert, this.workspaceService.data.mobileMode);
  }

  public searchChanged(search: string)
  {
    this.search = search;
  }

  ngAfterViewInit (): void {
    this.initScroll();
  }
  

  public initScroll()
  {
    $(this.alertsList.nativeElement).mCustomScrollbar({
        axis: "y",
        theme: "inset-3", // "minimal-dark",
        scrollbarPosition: "outside",
        alwaysShowScrollbar: 0, // 0,1,2
        scrollButtons: {
            enable: true
        },
        mouseWheel: {
            enable: true
        }
    });
  }
}
